<template>
  <div>
	  <div style="background:#00A6E5;display: flex;justify-content: center;">
	  	<div style="height: 80px;width: 60%;display: flex;align-items: center;justify-content: space-between;">
	  		<div style="display: flex;align-items: center;">
	  			<img src="../static/images/zuoniuren.png" style="width: 26px;height: 34px;">
	  			<span style="font-size: 28px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;line-height: 40px;margin-left: 14px;">牛人推荐</span>
	  		</div>
	  		<div style="width: 140px;height: 36px;border-radius: 4px;border: 1px solid #FFFFFF;display: flex;align-items: center;justify-content: space-around;cursor: pointer;" @click="gotoBecome">
	  			<img src="../static/images/addicon.png" style="width: 20px;height: 19.17px;">
	  			<span style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 22px;
	  		">加入牛人榜</span>
	  		</div>
	  	</div>
	  </div>
	  <div style="display: flex;justify-content: center;">
	  	<div style="width: 60%;display: flex;flex-wrap: wrap;">
			<div style="display: flex;flex:1;" v-for="item in showList">
				<div v-for="(items,index) in item"  style="margin-top: 30px;flex:1">
					<div  :style="items.id==0?'visibility:hidden;':''+'flex:1;background: #FFFFFF;box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);border-radius: 4px;'+((index+1)%4!=0?'margin-right:20px':'')">
						<div style="flex:1;" v-if="items.id&&items.id!=0">
							<div style="display: flex; align-items: center;padding:20px;">
								<img :src="IMG_HOST+items.avatar" style="width:60px;height:60px;">
								<div style="display: flex;flex-direction: column;margin-left: 20px;flex:1;">
									<span style="font-size: 18px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #333333;line-height: 25px;">{{items.nick_name}} <span style="color: #00A6E5;font-weight: bold;font-size: 14px;">{{items.type ? items.type : ''}}</span></span>
									<span style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #999999;line-height: 18px;margin-top: 6px;">{{items.desc}}</span>
								</div>
							</div>
							<div style="height: 1px;background: #EEEEEE;margin: 20px;"></div>
							<div style="display: flex;">
								<div class="str_tips" style="padding-left: 20px;">
									<div class="content_tips">
										<span class="tips_val_">增长</span>
										<span class="tips_val_">跟随</span>
										<span class="tips_val_">余额</span>
										<span class="tips_val_">盈利</span>
									</div>
									<div class="str_content">
										<span class="content_val">{{items.detail.growth_rate}}%</span>
										<span class="content_val">{{items.detail.follows}}</span>
										<span class="content_val">{{parseFloat(items.detail.balance.toFixed(2))}}</span>
										<span class="content_val">{{parseFloat(items.detail.profit.toFixed(2))}}</span>
									</div>
								</div>
								<div class="str_tips">
									<div class="content_tips">
										<span class="tips_val_">累计出金</span>
										<span class="tips_val_">累计入金</span>
										<span class="tips_val_">总隔夜费</span>
										<span class="tips_val_">总手续费</span>
									</div>
									<div class="str_content">
										<span class="content_val">{{parseFloat((Math.abs(items.detail.withdraw)).toFixed(2))}}</span>
										<span class="content_val">{{parseFloat(items.detail.deposit.toFixed(2))}}</span>
										<span class="content_val">{{parseFloat(items.detail.swap.toFixed(2))}}</span>
										<span class="content_val">{{parseFloat(items.detail.commission.toFixed(2))}}</span>
									</div>
								</div>
							</div>
							<div style="display: flex;justify-content: space-around;padding-bottom: 24px;padding-top: 20px;">
								<button class="btn_detail" style="cursor: pointer;"  @click="gotoNiurenDetail(items.id)">详情</button>
								<button class="btn_follow" style="cursor: pointer;" @click="gotoFollow(items)" >跟单</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	  </div>
	  <div style="display: flex;justify-content: center;margin-top: 70px;margin-bottom: 190px;" v-if="canLoad">
		  <button @click="loadData" style="width: 180px;height: 40px;background: #FFFFFF;border-radius: 4px;border: 1px solid #EEEEEE;font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #666666;line-height: 20px;">查看更多</button>
	  </div>
  </div>
</template>

<script>
	import {HOST,IMG_HOST} from '../Api.js'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data(){
	  return{
		list:[],
		showList:[],
		page:0,
		canLoad:false,
		IMG_HOST:IMG_HOST
	  }
  },
  mounted() {
  	this.loadData();
  },
  methods:{
	  gotoNiurenDetail(e){
		  // console.log(this.$router)
		  // console.log(this.$router.push)
		  console.log(e)
		  this.$router.push({name:'NiurenDetail',params:{id:e}})
	  },
	  gotoFollow(data){
		  this.$router.push({name:'Follow',params:{data:data}})
	  },
	  gotoBecome(){
		  this.$router.push('/BecomeNiuren');
	  },
	  loadData(){
		  this.$layer.loading({content:'数据加载中'});
		  this.page = this.page+1;
		  fetch(HOST+'biggun/list',{
			  method: 'POST',
			  headers:{
				  'content-type':'application/json'
			  },
			  body:JSON.stringify({
				  page:this.page,
				  limit:8
			  })
		  }).then(response =>response .json()).then(res=>{
			  this.$layer.closeAll();
			  if(res.code==0){
				  if(res.data&&res.data.length>=8){
					  this.canLoad = true;
				  }else{
					  this.canLoad = false;
				  }
				  this.list = this.list.concat(res.data);
				  let d = [];
				  this.showList = [];
				  for(let i = 0; i < this.list.length; i++){
					  
						  d.push(this.list[i]);
						  if(d.length==4){
							  this.showList.push(d);
							  d = [];
						  }else{
							  if((i+1)==this.list.length){
								this.showList.push(d);
								  d = [];
							  }
						  }
					  if((i+1)==this.list.length){
						  let cha = 4-(this.list.length)%4;
						  let idx = parseInt(this.list.length/4);
						  if(cha!=4){
							  let c = {
							  	id:0
							  }
							  for(let cc = 0; cc < cha; cc++){
								  this.showList[idx].push(c);
							  }
						  }
					  }
				  }
				  this.showList = JSON.parse(JSON.stringify(this.showList));
			  }else{
				  // alert(res.msg);
			  }
		  })
	  }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
	.str_tips{
		display: flex;
		flex: 1;
	}
	.str_content{
		display: flex;
		flex-direction: column;
		margin-left: 8px;
	}
	.content_tips{
		display: flex;
		flex-direction: column;
	}
	.content_val{
		font-size: 14px;
		font-family: Helvetica;
		color: #333333;
		line-height: 28px;
	}
	.tips_val_{
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		line-height: 28px;
	}
	.btn_detail{
		width: 110px;
		height: 36px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #DDDDDD;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 20px;
	}
	.btn_follow{
		width: 110px;
		height: 36px;
		border: 1px solid #00A6E5;
		background: #00A6E5;
		border-radius: 4px;
		color: white;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		line-height: 20px;
	}
</style>
